import React, { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';

interface AuthInterceptorProps {
  children: React.ReactNode;
}

const AuthInterceptor: React.FC<AuthInterceptorProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkIsAuthenticated } = useAuth();

  // Set up automatic token refresh and auth status checking
  // useEffect(() => {
  //   const setupAuthMonitoring = () => {
  //     // Clear any existing intervals
  //     if (refreshIntervalRef.current) {
  //       clearInterval(refreshIntervalRef.current);
  //     }
  //     if (checkIntervalRef.current) {
  //       clearInterval(checkIntervalRef.current);
  //     }

  //     // Check if user is authenticated
  //     const hasValidTokens = JWTManager.hasValidTokens();
      
  //     if (hasValidTokens) {
  //       console.log('Setting up auth monitoring for authenticated user');
        
  //       // Check auth status every 30 seconds
  //       checkIntervalRef.current = setInterval(() => {
  //         const stillValid = checkAuthStatus();
  //         if (!stillValid) {
  //           console.log('Auth status check failed - user no longer authenticated');
  //           // Clear intervals when user is no longer authenticated
  //           if (refreshIntervalRef.current) {
  //             clearInterval(refreshIntervalRef.current);
  //             refreshIntervalRef.current = null;
  //           }
  //           if (checkIntervalRef.current) {
  //             clearInterval(checkIntervalRef.current);
  //             checkIntervalRef.current = null;
  //           }
  //         }
  //       }, 30000);

  //       // Proactive token refresh every 10 minutes (if token expires in 15 minutes)
  //       refreshIntervalRef.current = setInterval(async () => {
  //         const accessToken = JWTManager.getAccessToken();
  //         if (accessToken && JWTManager.isTokenExpiringSoon(accessToken)) {
  //           console.log('Proactive token refresh triggered');
  //           try {
  //             await refreshToken();
  //           } catch (error) {
  //             console.error('Proactive token refresh failed:', error);
  //           }
  //         }
  //       }, 600000); // 10 minutes
  //     } else {
  //       console.log('No valid tokens found - skipping auth monitoring setup');
  //     }
  //   };

  //   // Initial setup
  //   setupAuthMonitoring();

  //   // Set up event listeners for visibility changes (when user returns to tab)
  //   const handleVisibilityChange = () => {
  //     if (!document.hidden) {
  //       console.log('Page became visible - checking auth status');
  //       setupAuthMonitoring();
  //     }
  //   };

  //   // Set up event listeners for focus changes (when user returns to window)
  //   const handleFocus = () => {
  //     console.log('Window focused - checking auth status');
  //     setupAuthMonitoring();
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   window.addEventListener('focus', handleFocus);

  //   // Cleanup function
  //   return () => {
  //     if (refreshIntervalRef.current) {
  //       clearInterval(refreshIntervalRef.current);
  //     }
  //     if (checkIntervalRef.current) {
  //       clearInterval(checkIntervalRef.current);
  //     }
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //     window.removeEventListener('focus', handleFocus);
  //   };
  // }, [refreshToken, checkAuthStatus]);

  const publicRoutes = [
    '/',
    '/login',
    '/register',
    '/reset-password',
    '/verify-email',
    '/confirm-email-change',
    '/forgot-password',
    '/terms',
    '/terms-of-use',
    '/privacy',
    '/account-deletion',
    '/quick-start-guide',
    '/user-manual',
  ];

  // Treat share links as public (no authentication required)
  const isPublicSharePath = (pathname: string) => {
    // Explicit public share routes
    if (pathname.startsWith('/public/share/')) return true;
    if (pathname.startsWith('/share/')) return true;

    // Direct short share code at root, e.g. "/HDZVK267GCFSMFJA"
    const shareCodePattern = /^\/[A-Za-z0-9]{8,32}$/;
    return shareCodePattern.test(pathname);
  };

  useEffect(() => {
    // Skip auth check for public routes and share links
    if (publicRoutes.includes(location.pathname) || isPublicSharePath(location.pathname)) {
      return;
    }
    const checkAuth = async () => {
      const result = await checkIsAuthenticated();
      if (result.success) {
        console.log("User authenticated");
      } else {
        console.log("User not authenticated");
        navigate('/login');
      }
    };

    checkAuth();

    // window.addEventListener('focus', checkAuth);

    // return () => {
    //   window.removeEventListener('focus', checkAuth);
    // }
    // Only run on mount to verify session. 
    // ProtectedRoute handles protection during internal navigation using the cached context state.
  }, [location.pathname]); 

  /* Get localstorage theme and set that to our application */
  useEffect(() => {
    const theme = localStorage.getItem("data-theme") ?? 'light';
    document.documentElement.setAttribute("data-theme", theme);
  }, [])

  return <>{children}</>;
};

export default AuthInterceptor; 